import { latLngToCell, cellToLatLng, gridDistance } from 'h3-js';
const H3_RESOLUTION = 7;
/** ~1.22 km edge length at resolution 7 */
const KM_PER_HEX_STEP = 1.22;
export function latLngToH3(lat, lng) {
    return latLngToCell(lat, lng, H3_RESOLUTION);
}
export function h3ToLatLng(h3Index) {
    const [lat, lng] = cellToLatLng(h3Index);
    return { lat, lng };
}
/** Grid distance in hex steps (returns -1 if indexes are in different pentagons) */
export function h3Distance(a, b) {
    return gridDistance(a, b);
}
/** Approximate km distance using H3 grid distance */
export function h3DistanceKm(a, b) {
    const dist = gridDistance(a, b);
    if (dist < 0)
        return -1;
    return dist * KM_PER_HEX_STEP;
}
//# sourceMappingURL=h3.js.map